import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { collectionActions } from '../../Actions';
import { paytmActions } from '../../Actions';
import Loader from '../../UILoader/Loader'
import './PaytmUI.css';

class PaytmUI extends Component {

    state = {
        loanId: '',
        amount: '',
        disableloanId: false,
        showConfirm: true,
        loanIdError:"",
        amountError:"",
        errors: {},
        business_name: '',
        disableButton: false
    }

    handleChange = e => {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        const re = /^[0-9a-zA-Z\b]+$/;
        const reg = /^\d*\.?\d*$/;
        if (name === "loanId") {
            if (value === '' || re.test(value)) {
                this.setState({ [name]: value,loanIdError:''})
            }
        } else if (name === "amount") {
            if (value === '' || reg.test(value)) {
                this.setState({ [name]: value, amountError:'' })
            }
        }
    }

    componentDidMount() {
        const { REACT_APP_USER_ID, REACT_APP_SECRET_KEY, REACT_APP_TYPE,REACT_APP_GA,REACT_APP_CUST_APP_URL } = process.env;
        window.location.href = REACT_APP_CUST_APP_URL+"/repay"+window.location.search;
        if(REACT_APP_GA) {
            ReactGA.initialize(REACT_APP_GA);
            ReactGA.pageview(window.location.pathname + window.location.search);
        };
        const authData = {
            user_id: REACT_APP_USER_ID,
            secret_key: REACT_APP_SECRET_KEY,
            type: REACT_APP_TYPE
        }
        this.props.postAuth(authData)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { REACT_APP_PAYTM_MID, REACT_APP_PAYTM_HOST } = process.env;
        const { paytm,collection } = nextProps;
        const errors = {};
        const regg = /^[0-9a-zA-Z\b]+$/;
        if(collection.authitems && collection.authitems.response && paytm && paytm.uuidInfo === undefined && !paytm.postloading && !paytm.posterror) {

            var uuid = nextProps.location && nextProps.location.search && nextProps.location.search.replace("?",'');
            const urlSearchParams = new URLSearchParams(nextProps.location && nextProps.location.search);
            const TOKEN = collection.authitems && collection.authitems.response && collection.authitems.response.auth && collection.authitems.response.auth.token;
            
            //payload method
            if(urlSearchParams.get('payload')) {
                var decodedString = atob(urlSearchParams.get('payload'));

                try{
                    let jsonData = JSON.parse(decodedString);
                    if(jsonData.loan_id && jsonData.loan_amount && this.state.disableloanId === false) {
                       this.setState({ loanId: jsonData.loan_id, amount: jsonData.loan_amount,disableloanId: true});
                    }
                }
                catch(e) {}               

            }//direct param case
            else if(urlSearchParams.get('loan_id') || urlSearchParams.get('amount')){
                var loanId = urlSearchParams.get('loan_id');
                var amount = urlSearchParams.get('amount');
                var new_payload = {errors: {}};
                if(regg.test(urlSearchParams.get('loan_id')) || Number(urlSearchParams.get('amount'))){
                    if(regg.test(urlSearchParams.get('loan_id')) && (loanId || amount) && this.state.disableloanId === false) {
                        this.setState({ loanId: loanId, amount: amount,disableloanId: true});
                    }
                }
                if(this.state.loanId === ''){
                    if(!regg.test(urlSearchParams.get('loan_id'))){
                        this.setState({loanIdError:"Invalid Loan ID"});
                    }
                }
                if(this.state.amount === ''){
                    if(!Number(urlSearchParams.get('amount'))){
                        this.setState({amountError:"Invalid amount"});
                    }
                }
            }
            else if(!(urlSearchParams.get('utm_source') || urlSearchParams.get('utm_medium') || urlSearchParams.get('utm_campaign')) && uuid && TOKEN){
                this.props.validatePaymentLink(uuid,TOKEN);
            }
        } 

        const businessName = paytm && paytm.items && paytm.items.data && paytm.items.data.attributes && paytm.items.data.attributes.company_name;
        const nextInitialPaytm = paytm && paytm.Items && paytm.Items.data.attributes;
        const nextError = paytm && paytm.error && paytm.error.length && paytm.items === undefined
        if (!!nextError) {
            this.setState({ showConfirm: true })
        }
        if(paytm && paytm.uuidInfo) {
            this.setState({ business_name: paytm.uuidInfo.data.attributes.business_name, showConfirm: false,loanId: paytm.uuidInfo.data.attributes.loan_application_id,amount: paytm.uuidInfo.data.attributes.amount })
        }
        if (businessName) {
            this.setState({ business_name: businessName, showConfirm: false })
        }
        const prevOrderId = this.props && this.props.paytm !== undefined && this.props.paytm.Items !== undefined && this.props.paytm.Items.data !== undefined && this.props.paytm.Items.data.attributes !== undefined && this.props.paytm.Items.data.attributes.order_id;
        if (nextInitialPaytm && nextInitialPaytm.order_id !== undefined && nextInitialPaytm.order_id !== prevOrderId) {
            const { order_id, amount, txn_token, mid } = nextInitialPaytm;
            let script = document.createElement('script');
            script.addEventListener('load', () => {
                var config = {
                    "root": "",
                    "flow": "DEFAULT",
                    "data": {
                        "orderId": order_id,
                        "token": txn_token,
                        "tokenType": "TXN_TOKEN",
                        "amount": amount
                    },
                    "handler": {
                        "notifyMerchant": function (eventName, data) {
                            console.log("notifyMerchant handler function called");
                            console.log("eventName => ", eventName);
                            if (eventName === "APP_CLOSED") {
                                this.setState({ disableButton: false })
                            }
                            console.log("data => ", data);
                        }.bind(this)
                    }
                };

                if (window.Paytm && window.Paytm.CheckoutJS) {
                    window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                        window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                            window.Paytm.CheckoutJS.invoke();
                        }).catch(function onError(error) {
                            if (error) {
                                errors['paytmError'] = error;
                            } else {
                                errors['paytmError'] = ""
                            }
                            console.log("error => ", error);
                        });
                    });
                }
                if (Object.values(errors).some(e => e !== "")) {
                    this.setState({ errors })
                }
            });
            script.src = `${REACT_APP_PAYTM_HOST}/merchantpgpui/checkoutjs/merchants/${mid}`;
            document.body.appendChild(script);
        }
    }

    confirmHandler = () => {
        const { collection } = this.props;
        const { loanId, amount } = this.state;
        const errors = {};
        if (loanId.length === 0) {
            errors['loanId'] = 'Please Enter Loan ID';
        } else {
            errors['loanId'] = '';
        }

        if (amount.length === 0) {
            errors['amount'] = 'Please Enter Amount';
        } else {
            errors['amount'] = '';
        }

        if (amount.length !== 0 && (+amount === 0 || +amount >= 10000000)) {
            errors['amountlength'] = 'Amount should be between 1 and 10000000';
        } else {
            errors['amountlength'] = '';
        }

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ errors })
            return
        }
        const TOKEN = collection.authitems.response.auth.token
        this.props.getLoanDetails(loanId, TOKEN)
        this.setState({ errors: {} })
    }

    paytmCheckout = () => {
        this.setState({ disableButton: true })
        const { collection,paytm } = this.props;
        const { loanId, amount } = this.state;
        let request = {
            payment: {
                loan_application_id: loanId,
                amount
            }
        };
        if(paytm && paytm.uuidInfo) {
            request.payment.uuid = paytm.uuidInfo.data.attributes.uuid;
        }
        const TOKEN = collection.authitems.response.auth.token;
        this.props.postInitialOrder(request, TOKEN)
    }

    goBack = () => {
        var that = this;
        this.setState({ showConfirm: true,disableButton: false }, () => that.props.paytmdefaultState());        
    }

    render() {
        const { showConfirm, loanId, amount,loanIdError,amountError, errors, business_name, disableButton,disableloanId } = this.state;
        const { paytm, collection } = this.props;
        return (
        <>   
        <Helmet>
            <title>Mintifi PayNow</title>
        </Helmet>
        <div className="payment-wrap">
            <div className="payment-left">
                <div className="payment-image-wrap">
                 <img src="/images/wallet-payment.svg " alt="Wallet-Payment" />
                </div>
            </div>
        <div className="payment-right">
        <div className="logo-payment">
            <img src="https://mintifi.com/media/logo.png" alt="Mintifi Logo" />
        </div>
         <h4>Repayment of Loan Due</h4>
            {!showConfirm ? (
             <p>Please ensure your Loan ID and Amount entered is correct</p>
                 ) : (
                    <p>Please enter your Mintifi assigned Loan ID and Amount to complete the Transaction </p>
                    )}
            {paytm &&
            "error" in paytm &&
            Array.isArray(paytm.error) &&
            paytm.error.length &&
            paytm.items === undefined
              ? paytm.error.map((err) => {
                return (
                <div key={err} style={{ textAlign: "center" }}>
                    {"detail" in err ? (
                        <div key={err} className="col-md-12 d-flex mb-2">
                            <div className="form-grp">
                                <span style={{ color: "crimson", fontSize: "16px" }}>
                                    {err.detail}
                                </span>
                            </div>
                        </div>
                    ) : null}
                </div>);
                })
              : null}
            <div style={{ textAlign: "center" }}>
            {collection.postautherror || 
            (paytm.posterror && Array.isArray(paytm.posterror) === false) ||
            (paytm.error && Array.isArray(paytm.error) === false) ? (
                <div className="col-md-12 d-flex" style={{ top: "21%" }}>
                    <div className="form-grp">
                        <span className="form-grp" style={{ color: "crimson", fontSize: "16px" }}>
                            Technical server error! Please try after some time.
                        </span>
                    </div>
                </div>
              ) : null}
            </div>
            {paytm &&
            "posterror" in paytm &&
            Array.isArray(paytm.posterror) &&
            paytm.posterror.length &&
            paytm.Items === undefined
              ? paytm.posterror.map((err) => {
                return (
                <div key={err} style={{ textAlign: "center" }}>
                    {"detail" in err ? (
                    <div key={err} className="col-md-12 d-flex mb-2">
                        <div className="form-grp">
                        <span className="form-grp" style={{ color: "crimson", fontSize: "16px" }}>
                        {err.detail}
                        </span>
                     </div>
                </div>
              ) : null}
            </div>
              )
            }) : null}
            {paytm.postloading && disableButton === true && <Loader />}
            {paytm.loading && <Loader />}
            {collection.postauthloading && <Loader />}
            <form action="" className="payment-form">
              <div className="form-grp">
                        <input
                          className={`form-field ${showConfirm === false && "readOnlyText"}`}
                          type="text"
                          id="loanId"
                          value={loanId}
                          name="loanId"
                          placeholder="Loan ID *"
                          disabled={disableloanId ? true : false}
                          readOnly={showConfirm === false ? true : false}
                          onChange={this.handleChange}
                          autoComplete="off"
                        />
              </div>
              <div className="form-grp-err">
                {loanIdError !== '' &&
                    <span style={{ color: "crimson", fontSize: "14px" }}>
                        {loanIdError}
                    </span>
                }
              </div>
              {!showConfirm ? (
                <div className="form-grp">
                    <input
                    type="text"
                    placeholder="Enter Business Name"
                    className={`form-field ${showConfirm === false && "readOnlyText"}`}
                    readOnly
                    value={business_name}/>
                    </div>
              ) : null}
              <div className="form-grp">
                <input
                  className={`form-field ${showConfirm === false && "readOnlyText"}`}
                  type="number"
                  id="amount"
                  name="amount"
                  placeholder="Enter Amount*"
                  onChange={this.handleChange}
                  readOnly={showConfirm === false ? true : false}
                  value={amount}
                  autoComplete="off"
                />
              </div>
              <div className="form-grp-err">
              {amountError !== '' &&
                    <span style={{ color: "crimson", fontSize: "14px" }}>
                        {amountError}
                    </span>
                }
                {errors.amountlength && errors.amountlength.length && (
                  <span style={{ color: "crimson", fontSize: "14px" }} >
                {errors.amountlength}
                  </span>
                )}
              </div>
              <div>
                <div>
                    {showConfirm ? (
                    <button type="button" className="butn butnBlue form-grp" onClick={this.confirmHandler}>
                     Confirm
                    </button>
                ) : (
                    <div className="row">
                        <div className="col-md-12 form-grp">
                        <button
                            type="button"
                            className="butn butnBlue"
                            disabled={disableButton ? true : false}
                            onClick={this.paytmCheckout}
                            >
                            Make Payment
                        </button>
                    </div>
                    {paytm && !paytm.uuidInfo && (
                    <div className="col-md-12 form-grp mb-3">
                        <button
                        type="button"
                        className="butn butnBlue"
                        onClick={() => this.goBack()}>
                        Go Back
                        </button>
                    </div>)} 
                </div>)}
               </div>
             </div>
            </form>
          </div>
        </div>
    </>
        )
    }
}

function mapState(state) {
    const { collection, paytm } = state;
    return { collection, paytm };
}

const actionCreators = {
    postAuth: collectionActions.postAuth,
    getLoanDetails: paytmActions.getLoanDetails,
    postInitialOrder: paytmActions.postInitialOrder,
    validatePaymentLink: paytmActions.validatePaymentLink,
    paytmdefaultState: paytmActions.paytmdefaultState
};

export default connect(mapState, actionCreators)(PaytmUI);
